/**
 * Design system color tokens for inline styles.
 * These values match @trendhunter/design-system dark mode.
 * CSS custom properties (--ds-*) are loaded via App.css.
 */

export const colors = {
  background: '#0f0f1a',
  surface: '#1e1e32',
  surfaceRaised: '#252540',
  surfaceOverlay: '#2d2d44',
  foreground: '#f8fafc',
  foregroundMuted: '#94a3b8',
  foregroundFaint: '#64748b',
  border: '#2d2d44',
  borderStrong: '#475569',
  accent: '#3b82f6',
  accentHover: '#2563eb',
  accentSecondary: '#6366f1',
  accentSecondaryHover: '#4f46e5',
};

export const scores = {
  high: '#10b981',
  highBg: '#166534',
  highFg: '#86efac',
  medium: '#f59e0b',
  mediumBg: '#854d0e',
  mediumFg: '#fde047',
  low: '#ef4444',
  lowBg: '#991b1b',
  lowFg: '#fca5a5',
};

export const statusColors = {
  new: { bg: '#fef3c7', text: '#92400e' },
  reviewing: { bg: '#dbeafe', text: '#1e40af' },
  approved: { bg: '#d1fae5', text: '#065f46' },
  declined: { bg: '#fee2e2', text: '#991b1b' },
};

export const brand = {
  indigo: '#6366f1',
  violet: '#8b5cf6',
  violetLight: '#a78bfa',
  amber: '#f59e0b',
  emerald: '#10b981',
  cyan: '#06b6d4',
};

export const tints = {
  indigo: '#6366f120',
  violet: '#8b5cf620',
  blue: '#3b82f620',
  emerald: '#10b98120',
  amber: '#f59e0b20',
  red: '#ef444420',
};

export function getScoreColor(score) {
  if (score >= 80) return scores.high;
  if (score >= 60) return scores.medium;
  return scores.low;
}
